/**
 * Removes custom tags (DIMENSION, DIMENSION_HIGHLIGHT, PERSON, FILE) from markdown text
 * and cleans up trailing commas and whitespaces
 *
 * @param text - The markdown text containing custom tags
 * @returns The cleaned text without custom tags, trailing commas, and extra whitespaces
 *
 */
export const cleanupMarkdownFromTags = (text: string): string => {
  if (!text) return text;

  // Remove all custom tags using a comprehensive regex pattern
  const cleaned = text
    .replace(
      /\[(?:DIMENSION_HIGHLIGHT|DIMENSION|PERSON|FILE|ASSESSMENT_REPORT|ASSESSMENT_PSYCH|PROJECT_DESCRIPTION):\d+(?::[^\]]+)?\]/g,
      ""
    )
    // Normalize spaces (but preserve newlines)
    .replace(/[^\S\n]+/g, " ")
    // Remove multiple consecutive commas and surrounding spaces (but not newlines)
    .replace(/[^\S\n]*,+[^\S\n]*/g, ", ")
    // Remove comma before punctuation
    .replace(/,\s*([.!?:])/g, "$1")
    // Remove trailing commas and spaces at end of lines
    .replace(/,[^\S\n]*$/gm, "")
    // Remove leading commas and spaces at start of lines
    .replace(/^[^\S\n]*,/gm, "")
    // Clean up lines that only contain commas and spaces
    .replace(/^[,\s]+$/gm, "")
    .trim();

  return cleaned;
};
